// AdminSelect.tsx
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataSuperAdmin } from "../redux/actions/common.action";
import { Select as ChakraReactSelect } from "chakra-react-select";

interface AdminSelectProps {
  setSelectedAdmin: (adminId: string | null) => void;
  selectedAdmin: string | null;
  endpoint: string;
}

interface Admin {
  Name: string;
  _id: string;
  active: boolean;
}

interface AdminLists {
  admins: Admin[];
  loading: boolean;
  signinuser: {
    UserType: number;
    userId: string;
  };
}

const AdminSelect: React.FC<AdminSelectProps> = ({
  setSelectedAdmin,
  selectedAdmin,
  endpoint,
}) => {
  const dispatch: any = useDispatch();
  const { admins, signinuser } = useSelector(
    (state: { common: AdminLists }) => state.common
  );

  const memoizedAdmins = useMemo(() => admins, [admins]);

  useEffect(() => {
    if (memoizedAdmins?.length === 0) {
      dispatch(getDataSuperAdmin("?limit=1000")); // initial fetch
    }
  }, [dispatch, memoizedAdmins?.length]);

  const options = [
    {
      value: signinuser?.userId, // extra option
      label: "self",
    },
    ...(admins?.map((admin) => ({
      value: admin._id,
      label: admin.Name,
    })) || []),
  ];

  return (
    <ChakraReactSelect
      placeholder="Select Admin"
      options={options}
      value={
        selectedAdmin
          ? options.find((opt) => opt.value === selectedAdmin) || null
          : null
      }
      onChange={(selected: any) => {
        const newAdminId = selected?.value || null;
        setSelectedAdmin(newAdminId);

        if (newAdminId) {
          dispatch(getDataSuperAdmin(`${endpoint}?parentId=${newAdminId}`));
        }
      }}
      chakraStyles={{
        container: (provided: any) => ({
          ...provided,
          width: "18rem",
          zIndex: 50, // so dropdown stays above modals etc.
        }),
      }}
    />
  );
};

export default AdminSelect;
